import type { UserProfile } from 'src/types/UserProfile';
import { api } from './api';

export const profileApi = api.injectEndpoints({
  endpoints: builder => ({
    getUserProfile: builder.query<UserProfile, void>({
      query: () => ({
        url: 'get-user-profile/',
        method: 'GET',
      }),
    }),
    updatePhoneNumber: builder.mutation<void, { mobile_number: string }>({
      query: payload => ({
        url: `update-user-profile/`,
        method: 'PATCH',
        body: payload,
      }),
    }),
    requestOTP: builder.mutation<void, { phone_number: string }>({
      query: payload => ({
        url: `verify_number/request-otp/`,
        method: 'POST',
        body: payload,
      }),
    }),
    validateOTP: builder.mutation<void, { phone_number: string; otp_to_verify: string }>({
      query: payload => ({
        url: `verify_number/validate-otp/`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetUserProfileQuery,
  useLazyGetUserProfileQuery,
  useUpdatePhoneNumberMutation,
  useRequestOTPMutation,
  useValidateOTPMutation,
} = profileApi;
